import React from "react"
import withContext from "utils/withContext"
import AdfoxAdaptive from "components/AdFoxAdaptive"

export function AdfoxTGB3_MT({ context }) {
    return (
        <AdfoxAdaptive
            options={ [
                {
                    ownerId: 407082,
                    containerId: "adfox_170229214256447269",
                    params: {
                        p1: "damhd",
                        p2: "inkd",
                        "partner-stat-id": context.analytics_lable
                    }
                },
                ["tablet", "phone"],
                {
                    tabletWidth: 830,
                    phoneWidth: 480,
                    isAutoReloads: true
                }
            ] }
        />
    )
}

export default withContext(AdfoxTGB3_MT)
